<template>
  <div class="home">
   <div class="dddd">
   	 <div id="myCarousel" class="carousel slide" data-interval='4000'>
    <!-- 轮播（Carousel）指标 -->
    <ol class="carousel-indicators">
        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
        <li data-target="#myCarousel" data-slide-to="1"></li>
        <li data-target="#myCarousel" data-slide-to="2"></li>
    </ol>   
    <!-- 轮播（Carousel）项目 -->
    <div class="carousel-inner">
        <div class="item active">	
            <img src="../../static/img/banner_01.jpg" alt="First slide">
        </div>
        <div class="item">
            <img src="../../static/img/banner_02.jpg" alt="Second slide">
        </div>
        <div class="item">
            <img src="../../static/img/banner_03.jpg" alt="Third slide">
        </div>
    </div>
    <!-- 轮播（Carousel）导航 -->
    <a class="carousel-control left" href="#myCarousel" 
        data-slide="prev">&lsaquo;
    </a>
    <a class="carousel-control right" href="#myCarousel" 
        data-slide="next">&rsaquo;
    </a>
		</div>
   </div>
   <div class="hserver">
   		<div class="server-tit">
   			<h4>服务领域</h4>
   			<p style="margin-top: 3px; font-size: 12px; font-family: Arial; color: #666;">SERVICE FIELD</p>
   			<div class="titlebg">
   				<img src="../../static/img/titlebg.png" style="margin-top: 13px;">
   			</div>
   		</div>
   		<div class="server-content">
   			<div class="content-detail" v-for="(item, index) in img">
	   				<div class="limitimg">
	   					<img :src="item.imgsrc" class="backimg"/>
	   					<transition name="slide-fadey">
	   					<img :src="imgicon[index].imgsrc" class="iconimg" v-show="show"/>
	   					</transition>
	   					
	   					<transition name="slide-fadey">
	   					<div class="imgdetail" v-show="show">
	   						<h3>{{imgicon[index].detailtit}}</h3>
	   						<p>{{imgicon[index].detailen}}</p>
	   					</div>
	   					</transition>
	   				</div>
   				
   			</div>
   		</div>
   </div>
   <div class="solvecase">
   		<div class="server-tit">
   			<h4>工程案例</h4>
   			<p style="margin-top: 3px; font-size: 12px; font-family: Arial; color: #666;">ENGINEERING CASE</p>
   			<div class="titlebg">
   				<img src="../../static/img/titlebg.png" style="margin-top: 13px;">
   			</div>
   		</div>
   		  <el-carousel :interval="4000" type="card" height="550px" @change = 'getin($event)'>
			    <el-carousel-item  v-for="(solve , index) in solvelist" v-bind:class="{solvesmaitem : solve.id != swipeindex}">
			    	<div class="solve-topop" v-bind:class="{solvesmatop : solve.id != swipeindex}">
			    		<img v-if="solve.id != swipeindex" :class="{noneimg : solve.id != swipeindex}" :src="solve.propic"/>
				    	<div class="solsma-icon" v-bind:class="{noneacic : solve.id != swipeindex}">
				    		<img v-if="solve.id == swipeindex" :src="solve.propic"/>
				    		<p v-bind:class="{noneacp : solve.id != swipeindex}" style="font-weight: bold; font-size: 16px; color: #333;">{{solve.protit}}</p>
				    	</div>
			    	</div>
			    	<div class="solsma-bottom">
			    		<p>{{solve.procontent}}</p>
			    	</div>
			    	<div class="solsma-footer">
			    		<router-link :to = 'falink[index]'>
			    		  <el-button @click = 'gotop()'>MORE</el-button>
							</router-link>
			    	</div>
			    </el-carousel-item>
			  </el-carousel>
   </div>
   <div class="news">
   	<div class="sanjiao">
   	</div>
   	<div class="newscon">
   		<div class="server-tit">
   			<h4>走进惠航</h4>
   			<p style="margin-top: 3px; font-size: 12px; font-family: Arial; color: #666;">ABOUT US</p>
   			<div class="titlebg">
   				<img src="../../static/img/titlebg.png" style="margin-top: 13px;">
   			</div>
   		</div>
	    <div class="syabout">
	    		<div class="leftwz">
	    			<p>惠州市惠航机电安装有限公司成立于1988年12月，2001年4 月20日改制为有限责任公
司，注册资金捌佰陆拾万元整,是电力工程施工总承包叁级、国家承装(修)类五级企业，
承担10千伏及以下电力工程的策划设计、安装及维修。公司于2007年6月加入广东省能
源协会，同年由中国工程建设与管理联合会授予“首批政府放心、用户满意示范企业”。
2008年7月取得广东省建设厅颁发的安全生产许可证，2009年4月取得城市及道路照明
工程专业承包三级资质，2012年通过...</p>
					<el-button type="primary" @click = "tohonme">Read more +</el-button>
	    		</div>
	    		<img src="../../static/img/syabout.png" style="margin-bottom: 60px; float: right;">
	    </div>
   	</div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    	img : [
    	{id : 1 , imgsrc : 'static/img/data_01.jpg' ,imglink : '#'},
    	{id : 2 , imgsrc : 'static/img/data_02.jpg' ,imglink : '#'},
    	{id : 3 , imgsrc : 'static/img/data_03.jpg' ,imglink : '#'},
    	],
    	imgicon : [
			{id : 1 , imgsrc : 'static/img/sy3_03.png' ,imglink : '#' , detailtit : '工厂厂房' , detailen : 'Factory building'},
			{id : 2 , imgsrc : 'static/img/sy3_02-06.png' ,imglink : '#' , detailtit : '住宅小区' , detailen : 'Residential quarters'},
			{id : 3 , imgsrc : 'static/img/sy3_01-09.png' ,imglink : '#' , detailtit : '办公大楼' , detailen : 'Office building'},
    	],
    	vuelink : [
			{id : 1 , vuelink : '/Technology/' + 0},
			{id : 2 , vuelink : '/Solve/' + 0},
			{id : 3 , vuelink : '/Technology/' + 0},
			{id : 4 , vuelink : '/Technology/' + 1},
    	],
    	falink : [
			{id : 0 , falink : '/Engineering/'},
			{id : 1 , falink : '/Engineering/'},
			{id : 3 , falink : '/Engineering/'},
			{id : 3 , falink : '/Engineering/'},
			{id : 4 , falink : '/Engineering/'},
    	],
    	detail :[
    	{id : 1 , imgsrc : 'static/img/industry03.jpg' , prolink : '/Product/' + 0},
    	{id : 2 , imgsrc : 'static/img/industry02.jpg' , prolink : '/Product/' + 1},
    	{id : 3 , imgsrc : 'static/img/industry01.jpg' , prolink : '/Product/' + 2},
    	{id : 4 , imgsrc : 'static/img/industry04.jpg' , prolink : '/Product/' + 3},
    	],
    	windows : [
    	{id : 1 , imgsrc : 'static/img/quick-nav-about.jpg' , winname : '公司简介' , imglink : '/Aboutcom/' + 0},
    	{id : 2 , imgsrc : 'static/img/quick-nav-wenhua.jpg' , winname : '企业文化' , imglink : '/Aboutcom/' + 2},
    	{id : 3 , imgsrc : 'static/img/quick-nav-zhaopin.jpg' , winname : '诚聘英才' , imglink : '/Zhaopin'},
    	{id : 4 , imgsrc : 'static/img/quick-nav-contact.jpg' , winname : '联系我们' , imglink : '/Contactu'},
    	],
    	solvelist :[
    	{id : 0 , imgsrc : 'static/img/sygcal.jpg'  , content : '惠州市华阳通用电子有限公司变配电工程',fotstit : '20KV及以下变配电电力安装工程施工，包括输（供）电线路工程20KV及以下变配电工程、及厂区厂房0.4KV低压配电安装工程...'},
    	{id : 1 , imgsrc : 'static/img/sygcal2.jpg'  , content : '惠州市经济技术学院供电工程',fotstit : '20KV及以下变配电电力安装工程施工，包括输（供）电线路工程20KV及以下变配电工程、及厂区厂房0.4KV低压配电安装工程...'},
    	{id : 2 , imgsrc : 'static/img/sygcal3.jpg'  , content : '惠州市华阳多媒体电子有限公司高低压配电工程',fotstit : '20KV及以下变配电电力安装工程施工，包括输（供）电线路工程20KV及以下变配电工程、及厂区厂房0.4KV低压配电安装工程...'},
    	{id : 3 , imgsrc : 'static/img/sygcal4.jpg' , content : '惠州市金山污水处理厂配电工程',fotstit : '20KV及以下变配电电力安装工程施工，包括输（供）电线路工程20KV及以下变配电工程、及厂区厂房0.4KV低压配电安装工程...'},
    	],
    	show : false,
    	height: 'auto',
    	bacshow : 0,
    	top : '0px',
    	width : '300px',
    	swipeindex :　0,
    }
  },
  mounted(){
    this.scor();
    this.getnews();
  },
  watch:{
  	show : function(){
  		this.gotheight()
  	}
  },
  methods:{
		scor(){
			var that = this;
				$(document).scroll(function(){
            		var htop = $(document).scrollTop();
            		if(htop>=200 & htop<750 ){
            			that.show = true
            		}else if(htop < 200 || htop >= 750){
            			that.show = false
            		}
            		
            	});
	 	},
	 	gotheight(){
	 			var htop = $(document).scrollTop();
   				var top =  $('.detail-pro')[0].clientHeight - 100 +'px'
   				this.top = top
   				var width =  $('.detail-pro')[0].clientWidth * 0.8 +'px'
   				this.width = width
	 				var he = $('.detail-pro')[0].clientHeight + 'px'
   				this.height = he
	 	},
	 	getheight(index){
	 		var that = this
	 			that.bacshow = index
	 	},
	 	outbac(){
	 			this.bacshow = 0
	 	},
	 	getin(val){
	 		this.swipeindex = val
	 	},
	 	gotop(){
				window.scrollTo(0,0)
		},
	 	getnews(){
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'protools'},{emulateJSON: true}).then((response) => {
     					var solvelist = [];
     					var falink = [];
     					for(var i = 0 ; i < 4 ; i++){
     					falink.push('/Engineerings/'+ response.body.recordset[i].id);
     					response.body.recordset[i].propic = response.body.recordset[i].propic.replace(/src="/ , '');
     					response.body.recordset[i].propic = response.body.recordset[i].propic.replace(/"/ , '');
     					var info = response.body.recordset[i].procontent;
     					info = info.replace(/(\n)/g, "");    
				        info = info.replace(/(\t)/g, "");    
				        info = info.replace(/(\r)/g, "");    
				        info = info.replace(/<\/?[^>]*>/g, "");    
				        info = info.replace(/\s*/g, ""); 
				        info = info.replace(/&nbsp;/g, ""); 
				        response.body.recordset[i].procontent = info;
     						solvelist.push(response.body.recordset[i]);
     					}
     					console.log(falink)
			        this.solvelist = solvelist;
			        this.falink = falink;
			      })
     		},
    todetail(id){
    			this.gotop();
     			this.$router.push('/Newsdetail/'+id);
     		},
    routerto(linkt){
    	this.gotop();
     	this.$router.push(linkt);
    },
    topro(linkt){
    	this.gotop();
     	this.$router.push(linkt);
    },
    	gotop(){
				window.scrollTo(0,0)
		},
    tohonme : function(){
  		this.$router.push('/About/')
  		this.gotop()
  	}
	},
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
h4{
	margin: 0;
	padding: 0;
}
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
p{
	    display: block;
    -webkit-margin-before: 0em;
    -webkit-margin-after: 0em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
}
.home{
	width: 100%;
	overflow: hidden;
}
.dddd{
	width: 100%;
}
.home .carousel-control{
	opacity: .3;
	align-items: center;
  display: flex;
}
.home .carousel-inner>.item>a>img, .carousel-inner>.item>img {
    line-height: 1;
    width: 100%;
}
.home{
	position: relative;
	width: 100%;
}

.home .carousel-control{
		padding: 0 70px;
    font-size: 60px;
}

.home .hserver{
	width: 75%;
	position: relative;
	clear: both;
	margin: 0 auto;
}

.server-tit{
	width: 100%;
	position: relative;
	margin: 0 auto;
	clear: both;
	margin: 60px auto 50px;
}
.server-tit h4{
	font-size: 26px;
	font-weight: bolder;
	color: #333333;
}
.content-detail{
	display: inline-block;
	position: relative;
	width: 33%;
}
.content-detail img{
	width: 100%;
	height: 100%;
	transition: all 1.3s;
}
.server-content{
	margin-bottom: 90px;
}
.limitimg{
	width: 90%;
	height: 90%;
	overflow: hidden;
}
.comsbottom{
	text-align: center;
	margin: 0 auto;
	position: absolute;
	bottom: 0;
	left: 0;
	width:100%;
	padding: 5px 0;
}
.com-bac{
	background: #000000;
	opacity: .4;
	width: 90%;
  height: 30px;
  position: absolute;
  bottom: 0;
  z-index: 0;
}
.limitimg img.backimg:hover{
	transform: scale(1.3);
}
.limitimg img.iconimg{
	position: absolute;
	z-index: 3;
	width: 20%;
  height: 20%;
  top: 24%;
  left: 36%;
}
.imgdetail{
	position: absolute;
	z-index: 3;
	bottom: 60px;
	width: 90%;
}
.imgdetail h3, .imgdetail p{
	color: #fff;
}
.slide-fadey-enter-active {
    transition: all .3s ease;
}
.slide-fadey-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fadey-enter, .slide-fadey-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(40px);
  opacity: 0;
}
.slide-fade-enter-active {
    transition: all .4s linear;
}
.slide-fade-leave-active {
    transition: all 0s  linear;
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fade-enter, .slide-fadey-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(40px);
}
.slide-fadex-enter-active {
    transition: all .4s linear;
}
.slide-fadex-leave-active {
    transition: all 0  linear;
}
/*.slide-fadey-enter, .slide-fadey-leave-to*/
.slide-fadex-enter, .slide-fadex-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-40px);
}
.solvecase,.news{
	position: relative;
	clear: both;
	background: #e0e9f1;
	width: 100%;
	padding: 30px 0;
	margin: 0 auto;
}
.product{
	position: relative;
	clear: both;
	width: 100%;
	padding: 30px 0;
	margin: 0 auto;
}

.sanjiao{
	position: absolute;
	width: 100%;
	height: 30px;
	width: 30px;
	background: #FFFFFF;
	margin: 0 auto;
	left: 48%;
	top: -15px;
	transform: rotate(45deg);
}
.home .pro-detail{
	position: relative;
	width: 80%;
	clear: both;
	margin: 20px auto;
	text-align: center;
}
.detail-pro{
	position: relative;
	width: 49%;
	clear: both;
	display: inline-block;
	margin: 20px auto;
}
.detail-pro img{
	width: 85%;
}
.change-pro{
	position: absolute;
	display: inline-block;
	width: 85%;
}
.back-pro{
	position: absolute;
	display: inline-block;
	width: 100%;
	z-index: 4;
	left:-100%;
	background: #2f5be2;
	opacity: .8;
}

.black{
	position: absolute;
	display: inline-block;
	width: 100%;
	left:-100%;
	background: black;
	opacity: .2;
}
.detail-pro img.pro-image{
	  position: absolute;
    width: 90px;
    left: -60%;
    top: 50px;
    z-index: 5;
}
.pro-line{
	position: absolute;
	width: 50px;
	border-bottom: 5px solid #FFF;
	opacity: .8;
	border-radius: 10px;
	left: -18.5vw;
  top: 180px;
  z-index: 5;
}
.change-pro h3{
	position: absolute;
	color: #FFF;
	z-index: 5;
	width: 200px;
	left: -140%;
	top: 3vw;
}
.change-pro p{
	position: absolute;
	color: #FFF;
	z-index: 5;
	width: 80%;
  left: -27.5vw;
  font-size: 14px;
}
.comlist{
	position: relative;
	clear: both;
	display: inline-block;
	width: 48%;
	text-align: left;
}
.newslist{
	position: relative;
	clear: both;
	display: inline-block;
	width: 48%;
	text-align: left;
	float: right;
}
.newscon{
	position: relative;
	clear: both;
	width: 1080px;
	margin: 0 auto;
}
.comstit{
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
	width: 90%;
}
.comstit span{
	font-size: 16px;
}
.comswindows{
	padding: 25px 2%;
	position: relative;
	clear: both;
}
.windowslist{
	width: 47%;
	position: relative;
	display: inline-block;
	clear: both;
	margin-bottom: 20px;
}
.windowslist img.winlist{
	width: 90%;
	position: relative;
}
.news{
	background-color: #fff !important;
	padding: 40px 0 30px !important;
}
.newsli{
	padding: 2% 0;
	position: relative;
}
.newsli li{
	list-style: none;
	line-height: 40px;
  border-bottom: 1px solid #ddd;
  width: 90%;
  margin: 0 ;
  font-size: 13px;
  position: relative;
  display: inline-block;
}
.newsli ul{
	overflow: hidden;
}
.lidata{
	position: absolute;
	right: 0;
	display: inline-block;
	top: 0;
	color: #660000;
}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #fff;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #fff;
  }
  .solsma-tit{
  	position: relative;
  	clear: both;
  	height: 60px;
  	background: #0066ef;
  }
  .el-carousel__item .solsma-tit h3{
  	line-height: 60px;
  	color: #FFFFFF;
  	font-size: 18px;
  	font-weight: 600;
  	opacity: 1;
  }
  .solsma-icon{
  	position: relative;
  	padding-top:30px ;
  	
  }
  .solsma-icon p{
  	padding: 30px 15%;
  	color: #8c93a0;
  }
  .solsma-bottom{
  	padding: 10px 10%;
  	text-align: left;
  	position: relative;
  	height: 47px;
  	overflow-y: hidden;
  }
  .solsma-bottom p{
  	color: #8c93a0;
  }
  .solsma-bottom p b{
  	color: #555555;
  }
  
  .solsma-footer{
  	padding: 34px 15%;
  	position: relative;
  }
  .solvecase .el-carousel{
  	width: 70%;
    margin: 0 auto;
  }
  .pro-p{
  	margin: 0 auto;
  	top: 13vw;
  	position: absolute;
  }
  .com-p{
  	color: #FFFFFF;
  	z-index: 4;
  	width: 90%;
  	position: relative;
  }
  .solvecase .noneac{
  	background: none !important;
  	width: 100%;
  }
  .solvecase h3.noneach3{
  	color: #333333;
  }
  .solvecase p.noneacp{
  	margin: 0px 0 30px;
  	padding: 10px 15% 30px;
  	width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .solvesmatop{
  	background: #F0F4F8;
  }
  .solvecase img.noneimg{
  	padding-top: 50px;
  }
  .solvecase .noneacic{
  	padding-top: 0 !important;
  }
  .solvesmaitem{
  	/*transform: scale(0.93) !important;*/
  }
  .titlebg{
  	height: 3px;
  	margin: 0 auto;
  	width: 250px;
  }
  .solsma-bottom[data-v-7cbbe74f] {
    padding-top: 0;
    padding-bottom: 0;
}
	.solvecase[data-v-7cbbe74f], .news[data-v-7cbbe74f] {
 	padding: 30px 0 70px;
}
.el-button:focus, .el-button:hover {
    color: #da251c !important;
    border-color: #ff8f89 !important;
    background-color: #ffe7e6 !important;
}
.server-content[data-v-7cbbe74f] {
    margin-bottom: 70px !important;
}
.home .hserver[data-v-7cbbe74f] {
    padding-top: 50px;
}
.server-tit[data-v-7cbbe74f] {
    margin: 10px auto 50px;
}
.solvecase[data-v-7cbbe74f][data-v-7cbbe74f] {
    padding: 50px 0 70px !important;
}
.sanjiao[data-v-7cbbe74f] {
    left: 49% !important;
}
.leftwz{
	float: left;
	width: 50%;
	text-align: left;
	line-height: 30px;
	padding-right: 30px;
	color: #666;
}
.el-button--primary {
    color: #fff;
    background-color: #e01313;
    border-color: #e01313;
    margin-top: 40px;
}
.el-button {
    padding: 12px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue